import { create } from "zustand";
export var useVehicleGallery = create(function(set) {
    return {
        setImageIndex: function(index) {
            return new Promise(function(res) {
                return res(set({
                    imageIndex: index
                }));
            });
        },
        imageIndex: null,
        imageIndexes: null,
        setImageIndexes: function(images, sections) {
            var ref, ref1, ref2, ref3;
            var interiorSectionImageIndex = images === null || images === void 0 ? void 0 : images.map(function(image) {
                return image.id;
            }).indexOf((ref = sections.interior.image) === null || ref === void 0 ? void 0 : ref.id);
            var performanceSectionImageIndex = images === null || images === void 0 ? void 0 : images.map(function(image) {
                return image.id;
            }).indexOf((ref1 = sections.performance.image) === null || ref1 === void 0 ? void 0 : ref1.id);
            var practicalitySectionImageIndex = images === null || images === void 0 ? void 0 : images.map(function(image) {
                return image.id;
            }).indexOf((ref2 = sections.practicality.image) === null || ref2 === void 0 ? void 0 : ref2.id);
            var runningCostsSectionImageIndex = images === null || images === void 0 ? void 0 : images.map(function(image) {
                return image.id;
            }).indexOf((ref3 = sections.runningCosts.image) === null || ref3 === void 0 ? void 0 : ref3.id);
            set({
                imageIndexes: {
                    interiorSectionImageIndex: interiorSectionImageIndex,
                    performanceSectionImageIndex: performanceSectionImageIndex,
                    practicalitySectionImageIndex: practicalitySectionImageIndex,
                    runningCostsSectionImageIndex: runningCostsSectionImageIndex
                }
            });
        }
    };
});
